import { render } from "./FaqCategoryForm.vue?vue&type=template&id=2ccd56da"
import script from "./FaqCategoryForm.vue?vue&type=script&lang=js"
export * from "./FaqCategoryForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__